import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { vReveal } from './directives/reveal'
import { blockNumberInputWheel } from './utils/blockNumberInputWheel'
import '@mdi/font/css/materialdesignicons.css'
import './assets/styles/main.scss'

/* number 인풋 포커스 중 휠로 값이 바뀌는 기본 동작 차단 */
document.addEventListener('wheel', blockNumberInputWheel, { passive: false, capture: true })

createApp(App).use(router).directive('reveal', vReveal).mount('#app')
